export default __webpack_public_path__ + "static/media/09_ghidoni.eda53808.gif";